<script>
    // based on suggestions from:
    // Inclusive Components by Heydon Pickering https://inclusive-components.design/toggle-button/
    // On Designing and Building Toggle Switches by Sara Soueidan https://www.sarasoueidan.com/blog/toggle-switch-design/
    // and this example by Scott O'hara https://codepen.io/scottohara/pen/zLZwNv 


    export let label;
	export let fontSize = 16;
	export let value;
    export let onChange;
    export let focusableElementID = "switch";

    $: checked = value;
    //$: console.log("currently checked: " + checked)
	const uniqueID = Math.floor(Math.random() * 100)
    function handleClick(event){
        onChange()
    }
</script>


<div class="s s--slider" style="font-size:{fontSize}px" >
    <span class="switchlabel" id={`switch-${uniqueID}`}>{label}</span>
    <button
        role="switch"
        aria-checked={checked}
        aria-labelledby={`switch-${uniqueID}`}
        id={focusableElementID}
        on:click={handleClick}>
    </button>
</div>

<style>
	:root {
		--accent-color: #424242;
		--gray: #DFDFDF;
	}
      /* Slider Design Option */

    .s--slider {
        display: flex;
        align-items: center;
    }

    .s--slider button {
        width: 3em;
        height: 1.6em;
        position: relative;
        margin: 0;
        background: var(--gray);
        border: 1px solid var(--gray);
    }

    .s--slider button::before {
        content: '';
        position: absolute;
        width: 1.3em;
        height: 1.3em;
        background: linear-gradient(180deg, #FFFFFF 0%, #E8EAEA 100%);
        top: 0.13em;
        right: 1.5em;
        transition: transform 0.3s;
    }

    .s--slider button[aria-checked='true']{
        background-color: var(--accent-color)
    }

    .s--slider button[aria-checked='true']::before{
        transform: translateX(1.3em);
        transition: transform 0.3s;
    }

    .s--slider button:focus {
        box-shadow: 0 0px 0px 1px var(--accent-color);
    }
    .s--slider button {
        border-radius: 1.5em;
    } 
    
    .s--slider button::before {
        border-radius: 100%;
    }

    .s--slider button:focus {
        box-shadow: 0 0px 8px var(--accent-color);
        border-radius: 1.5em;
    }
    .switchlabel{
        display:none;
    }
</style>